import { FileDown, ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { LeadDialog } from "@/components/LeadForm";
import { FadeIn, Chapter } from "@/components/Motion";
import { DOWNLOADS } from "@/data/content";

export default function Downloads() {
  return (
    <>
      <PageHero
        overline="Download Center"
        lines={["Catalogues, certificates,", "CAD and media"]}
        sub="Everything a distributor, OEM partner or specifier needs. Files are shared with registered professional contacts — request access and our team delivers within 48 hours."
      />

      <section className="bg-white pb-24 sm:pb-32" data-testid="downloads-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Chapter index="01" label="Resources" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {DOWNLOADS.map((d, i) => (
              <FadeIn key={d.name} delay={(i % 3) * 0.06}>
                <div
                  className="group h-full rounded-2xl border border-slate-200/80 bg-[#F8F9FA] p-7 flex flex-col hover:border-signal/40 transition-colors duration-300"
                  data-testid={`download-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <div className="flex items-start justify-between">
                    <span className="w-10 h-10 rounded-xl bg-white border border-slate-200/80 flex items-center justify-center">
                      <FileDown size={17} className="text-slate-700" />
                    </span>
                    <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-slate-400 border border-slate-200 rounded-full px-2.5 py-1">
                      {d.type}
                    </span>
                  </div>
                  <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-slate-950">{d.name}</h3>
                  <p className="mt-1.5 text-sm text-slate-600 leading-relaxed flex-1">{d.desc}</p>
                  <LeadDialog
                    defaultType="download"
                    context={`Download request: ${d.name}`}
                    title={`Request: ${d.name}`}
                    trigger={
                      <button
                        data-testid={`download-btn-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
                        className="mt-5 inline-flex items-center gap-1.5 text-[13px] font-medium text-slate-950 group-hover:text-signal transition-colors self-start"
                      >
                        Request access <ArrowUpRight size={13} />
                      </button>
                    }
                  />
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <CTABand
        overline="Resources"
        lines={["Need something", "more specific?"]}
        primary={{ to: "/contact?type=sales", label: "Talk with our team", testid: "downloads-cta" }}
        secondary={{ to: "/contact?type=distributor", label: "Become a Distributor", testid: "downloads-cta-dist" }}
      />
    </>
  );
}
